import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Footer from './Homepages/Footer';
import { Helmet } from "react-helmet-async";
import axios from 'axios';
import parse from 'html-react-parser';

const AboutUs = () => {

  const [about, setAbout] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch the About Us page data from the API
        const response = await axios('https://admin.techno-elevators.com/api/getAboutUsPageDataBySlug/about-us');
        setAbout(response.data.data); // Store the response data in state
      } catch (err) {
        console.log(err); // Log any error if the request fails
      }
    };
    fetchData();
  }, []); // The empty dependency array ensures the effect runs only once when the component mounts


  return (
    <>
      {/* Helmet for SEO purposes */}
      <Helmet>
        <title>About Techno Elevators Oman | Elevator & Escalator Experts</title>
        <meta name="description" content="Techno Elevators Oman specializes in high-quality elevators, escalators, and travelators with a focus on safety, innovation, and excellent service across Oman." />
        <meta name="keywords" content="techno elevators for villas,techno elevators for office buildings,commercial techno lift installation,high-rise techno elevators,techno elevator services in Muscat,elevator installation cost,home elevator installation near me,residential elevator installation,home elevator installers,lift installation services,elevator repair near me" />
        <link rel="canonical" href="https://www.techno-elevators.com/about-us" />
      </Helmet>

      {/* About Us Section */}
      <section className="about-page spad">
        <Container>
          <Row>
            {/* Section Title */}
            <div className="text-center mb-5 mt-5 section-title">
              <p className="about-heading">{about?.about_us_section?.category_title_en}</p>
            </div>

            {/* About Us Content */}
            <Col lg={12} md={8}>
              <Row className="mb-5">
                <Col lg={6}>
                  <div className="about__page__services__text">
                    <h5>{about?.about_us_section?.sub_category_title_en}</h5>
                    <div>{about?.about_us_section?.highlight_en && parse(about?.about_us_section?.highlight_en)}</div>
                  </div>
                </Col>
                <Col lg={6}>
                  <img src='/Images/about/about_us.jpg' width={'100%'} style={{ objectFit: 'cover', height: '100%' }} alt="capsule / panoramic elevators" />
                </Col>
              </Row>

              {/* Our New Vision Section */}
              <div className="about__page__services">
                <Row className="mt-5" style={{ display: "flex", justifyContent: "center" }}>
                  {about?.our_new_vision?.sections.map((item, index) => (
                    <Col lg={6} md={6} sm={6} key={index}>
                      <div className="services__item">
                        <div className="text-center">
                          <img className="mb-4" src={item.icon_file_or_image} alt={item.section_title_en} width={'70px'} />
                          <h4 className="mb-4">{item.section_title_en}</h4>
                        </div>
                        <p>{item.description_en && parse(item.description_en)}</p>
                      </div>
                    </Col>
                  ))}

                  {/* Why Choose Us Section */}
                  <Col lg={12} className="mb-5">
                    <Row style={{ display: 'flex', justifyContent: 'center' }}>
                      <Col lg={9}>
                        <div>
                          <h3 className="text-center mt-5 mb-5">{about?.why_choose_us?.category_title_en}</h3>

                          {about?.why_choose_us?.sections.map((item, index) => (
                            <Accordion key={index} defaultActiveKey="0">
                              <Accordion.Item eventKey={item.menu_id}>
                                <Accordion.Header>
                                  <strong>{item.section_title_en}</strong>
                                </Accordion.Header>
                                <Accordion.Body>
                                  {item.description_en && parse(item.description_en)}
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          ))}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default AboutUs;

